import React, {Component} from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {Button, Form, Input, DatePicker, Tabs} from 'antd';
import MyTable from '@/components/MyTable'

const {TabPane} = Tabs;

class CooperativeMerchant extends Component {
    searchFormRef = React.createRef();
    state = {
        pageTitle: '董监高',
        selectedRowKeys: [],
    }
    componentDidMount() {
        this.pageRefresh()
    }

    componentWillUnmount() {
        //在组件销毁的时候将异步方法撤销
        this.setState = () => {
            return
        }
    }
    yearChange = (date, dateString) => {
        this.setState({year: dateString}, () => {});
    }
    setTabActiveKey = (key) => {
        this.setState({tabActiveKey: key}, () => {
            this.pageRefresh()
        });
    }
    pageRefresh = () => {
        const query = this.searchFormRef.current.getFieldsValue()
        const postData = {
            ...query
        }
        this.child.getList(postData)
    }
    onSearchFinish = values => {
        this.pageRefresh()
    }
    onSearchReset = () => {
        this.searchFormRef.current.resetFields()
        this.pageRefresh()
    }
    onSelectChange = selectedRowKeys => {
        this.setState({selectedRowKeys});
    }

    //表格数据获取成功后赋值
    getListSuccess = (data) => {
    }
    onMyTableRef = (ref) => {
        this.child = ref
    }

    render() {

        const {selectedRowKeys} = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
        };


        const columns = [
            {title: '序号', key: 'index', width: 80, render: (text, record, index) => `${index + 1}`, align: 'center',},
            {title: '人员姓名', dataIndex: 'executiveName', key: 'executiveName', width: 150, align: 'center'},
            {title: '职位名称', dataIndex: 'executiveJob', key: 'executiveJob', width: 150, align: 'center'},
            {title: '所属商户', dataIndex: 'customerName', key: 'customerName', width: 150, align: 'center'},
            { title: '是否在平台注册', dataIndex: 'autoPT', render:()=> ('否'), width: 130,  align: 'center',},
        ];

        return (
            <div className="test">
                <p>{this.state.pageTitle}</p>
                <Form className="search-form" ref={this.searchFormRef} name="searchForm" layout="inline"
                      onFinish={this.onSearchFinish}>
                    <Form.Item name="customerName" label="商户名称：">
                        <Input placeholder="请输入" allowClear autoComplete="off"/>
                    </Form.Item>
                    <Form.Item>
                        <Button htmlType="submit" type="primary">查询</Button>&nbsp;
                        <Button htmlType="button" onClick={this.onSearchReset}>重置</Button>
                    </Form.Item>
                </Form>
                <MyTable
                    title={this.state.pageTitle}
                    onRef={this.onMyTableRef}
                    rowSelection={rowSelection}
                    rowKey="id"
                    url="/coreCustomer/executive/list"
                    columns={columns}
                    callback={this.getListSuccess}></MyTable>
            </div>
        )
    }
}

const mapStateToProps = ({signTime}) => {
    return {
        signTime
    }
}

export default connect(
    mapStateToProps,
)(withRouter(CooperativeMerchant))
